import {
  Component,
  ContentChild,
  Input,
  OnInit,
  TemplateRef
} from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AuthService } from "../../services";
import { selectUserSession } from "../../selectors/index";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit {
  fullName: string;
  physSection: boolean;
  adminSection: boolean;
  facility: Facility;

  patientSection: boolean;
  @Input()
  logoutUrl: string;
  @ContentChild("titleContent")
  titleContent: TemplateRef<any>;

  constructor(
    public router: Router,
    private authService: AuthService,
    private store: Store<any>
  ) {
    let user: User = authService.getUser() || <User>{};
    this.fullName = user.Name;
  }

  ngOnInit() {
    let url = this.router.url;
    let urlSection = url.split("/")[1];
    this.patientSection = "patient-portal" === urlSection;
    selectUserSession(this.store).subscribe(session => {
      if (session) {
        this.facility = session.Facility;
      }
    });
  }

  onLoggedout() {
    sessionStorage.clear();
    this.store.dispatch({ type: "LOGOUT" });
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/header/header.component.ts